import { BCMSCurrency, BCMSValidate } from "@bcm-dev/bcms-vite";
import React, { useEffect, useState } from "react";
import { SVGAsset } from "res";
import UITextInput from "../UITextInput";
import "./styles.css";

/**
 * @function UIAmountInput 
 * @param {STRING} value - Allows to set the value of the text input. 
 * @param {STRING} onChange - Event handler that allows the input to change it’s value when someone is typing in it. 
 * @returns {React.Component}
 * @example
 * <UIAmountInput value="0.00" onChange={e => {handleChange(e)}}/>
 */
 export default function UIAmountInput(props) {
  const point = props["data-point"] ? props["data-point"] : props.dataPoint ?? "";

  const formatEmpty = props.formatEmpty ?? true;
  const formatOnBlur = props.formatOnBlur ?? true;

  let value = BCMSValidate.isNumber(props.value) || props.value === ""
    ? BCMSCurrency.init(props.value).format().slice(1) : props.value;
  const [ state, setState ] = useState({ "input" : value ?? "", "close" : false });

  const onChange = (value, evt) => {
    const newValue = BCMSValidate.isNumber(value) || value === "" ? value : state.input;
    setState({ "input": newValue, "close": value.length > 0 });

    if(props.onChange instanceof Function) {
      props.onChange(BCMSCurrency.init(newValue), evt);
    }
  };

  const onFocus = (value, evt) => {
    const newValue = BCMSCurrency.init(value).amount;
    setState({ "input": newValue, "close": value.length > 0 });
  };

  const onBlur = (value, evt) => {
    let newValue = value;

    if(formatOnBlur && (formatEmpty || (!formatEmpty && value !== ""))) {
    
      newValue = BCMSCurrency.init(value).format().slice(1);
    }

    setState({ "input": newValue, "close": newValue.length > 0 });

    if(props.onBlur instanceof Function) {
      props.onBlur(BCMSCurrency.init(value), evt);
    }
  }

  const reset = evt => {
    setState({ "input" : "", "close" : false });

    if(props.onChange instanceof Function) {
      props.onChange("");
    }
  };

  // Added useEffect to reset state when the props.value is either undefined or is an empty string
  useEffect(() => {
    if(props.value === undefined || props.value === "") {
      setState({ "input": "", "close": false });
    } else {
      setState({ "input": props.value, "close": props.value.length > 0 });
    }
  }, [ props.value ]);

  return (
      <div className="ui-amount-input">
          <div className="flex-container flex-horizontal align-center">
              <span>$</span>
              <UITextInput value={ state.input } data-point={ point } onChange={ onChange } onFocus={ onFocus } onBlur={ onBlur }/>
              { state.close && <SVGAsset id="CloseX" onClick={ reset } className="clickable" /> }
          </div>
      </div>
  );
}